import { Layout } from '@eneco/flows/components';
import { createFlowProvider } from '@eneco/flows/utils';

import { FlowContextDeceased } from '../context';
import { actions, initialContext, routes } from './DeceasedCancelationFlow.config';

const { Provider, Navigation, Router } = createFlowProvider<FlowContextDeceased>({ routes, actions, initialContext });
const Flow = () => (
  <Provider>
    <Layout>
      <Layout.Header>
        <Navigation componentName="DeceasedFlowNavigation" />
      </Layout.Header>
      <Router />
    </Layout>
  </Provider>
);

export default Flow;
